import { useEffect, useState } from 'react'

// False until after hydration. Gate anything derived from cookies, localStorage or client-only
// feature flags on this, so the first client render still matches the prerendered HTML.
export default function useIsMounted(): boolean {
  const [isMounted, setIsMounted] = useState(false)
  useEffect(() => setIsMounted(true), [])
  return isMounted
}
